import React from 'react'
import tw from "twin.macro";
import styled from "styled-components";
import SubHeadings from './SubHeadings';
const DescContainer = tw.div`mb-4 p-5 bg-white rounded-lg   hover:shadow-lg `;

const DescriptionContainer = ({data}) => {
  return (
    <>
      <SubHeadings heading1="How" heading2="it works"/>
    <DescContainer>
 
        <ol className="list-disc pl-6">
          {data.map((item, index) => (
            <li key={index} className=" mt-1 text-justify md:text-justify  sm:text-justify text-gray-700 leading-relaxed ">
              {item.description}
            </li>
          ))}
        </ol>
      </DescContainer>
      </>
  )
}

export default DescriptionContainer